import { computed } from "vue";
import { toBoolean } from "#ce/utils/props";

/**
 * Returns where the search icon draws: `showStartIcon` before the field, `showEndIcon` after it (`icon-position="end"`),
 * neither with `no-icon`.
 *
 * @param {{noIcon?: boolean|string, iconPosition?: string}} props
 */
export function useSearchBoxPresentation(props) {
  const showIcon = computed(() => !toBoolean(props.noIcon));
  const iconAtEnd = computed(() => props.iconPosition === "end");
  const showStartIcon = computed(() => showIcon.value && !iconAtEnd.value);
  const showEndIcon = computed(() => showIcon.value && iconAtEnd.value);

  return {
    showStartIcon,
    showEndIcon,
  };
}
